<template>
  <h1 class="text-primary-600 text-2xl! leading-10 font-normal!">
    <slot />
  </h1>
</template>

<script setup lang="ts">
  type Slots = {
    default: never
  }

  defineSlots<Slots>()
</script>
